import { isMobileView } from '../utilities/index.js';

(function () {
  'use strict';

  const SELECTORS = {
    trigger: '.js-list-trigger',
    subList: '.subList',
    link: '.list_link',
  };

  const CLASS_OPEN = 'is-open';

  const slideUp = (el, duration = 300) => {
    el.style.height = `${el.scrollHeight}px`;
    requestAnimationFrame(() => {
      el.style.transition = `height ${duration}ms ease`;
      el.style.height = '0';
    });

    setTimeout(() => {
      el.style.removeProperty('height');
      el.style.removeProperty('transition');

      const item = el.closest(SELECTORS.trigger);
      if (item) {
        item.classList.remove(CLASS_OPEN);
      }
    }, duration);
  };

  const slideDown = (el, duration = 300) => {
    el.style.height = '0';
    const height = el.scrollHeight;

    const item = el.closest(SELECTORS.trigger);
    if (item) {
      item.classList.add(CLASS_OPEN);
    }

    requestAnimationFrame(() => {
      el.style.transition = `height ${duration}ms ease`;
      el.style.height = `${height}px`;
    });

    setTimeout(() => {
      el.style.removeProperty('height');
      el.style.removeProperty('transition');
    }, duration);
  };

  const initFooterAccordion = () => {
    if (!isMobileView()) return; // PC時は何もしない

    document.querySelectorAll(SELECTORS.trigger).forEach((item) => {
      const link = item.querySelector(SELECTORS.link);
      const subList = item.querySelector(SELECTORS.subList);
      if (!link || !subList) return;
    
      link.addEventListener('click', (e) => {
        e.preventDefault();
    
        const isOpen = item.classList.contains(CLASS_OPEN);
    
        if (isOpen) {
          slideUp(subList);
        } else {
          slideDown(subList);
        }

        link.classList.toggle(CLASS_OPEN);
      });
    });
    
  };

  initFooterAccordion();

  let currentMode = isMobileView() ? 'sp' : 'pc';
  let resizeTimer = null;

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      const newMode = isMobileView() ? 'sp' : 'pc';
      if (newMode !== currentMode) {
        location.reload();
        currentMode = newMode;
      }
    }, 200);
  });
})();
